import React, { useContext, Fragment, useEffect } from "react";
import { TipoAgendamentoContext } from "../TipoAgendamentoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarTipoAgendamento = () => {
  const { values, setValues, resetScreen } = useContext(TipoAgendamentoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={TipoAgendamentoContext}>
        <div className="col-12 col-md-4">
          <label>Descrição</label>
          <input
            className="form-control"
            type="text"
            name="tipoAgendamentoDescricao"
            value={values.searchData.tipoAgendamentoDescricao}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={TipoAgendamentoContext} />
    </Fragment>
  );
};

export default PesquisarTipoAgendamento;
